module.exports = __webpack_public_path__ + "img/Liputan-Image-6.461aa5a2.jpg";